import MarketHeader from '@envato/market-shared-header'
import { connect } from 'react-redux'

import { IRootState } from '../../../common/reducers'
import { getMarketHeaderUser } from '../../../common/selectors/user'

interface IStateProps {
  user: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  return {
    user: getMarketHeaderUser(state)
  }
}

const MarketHeaderContainer = connect<IStateProps, void, any, IRootState>(
  mapStateToProps
)(MarketHeader)

export default MarketHeaderContainer
